import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
  memo,
  forwardRef,
  useImperativeHandle,
} from "react";
import BasicInfo from "./BasicInfo";
import ProductItem from "./ProductItem";
import { AsyncPaginate } from "react-select-async-paginate";
import CreatableSelect from "react-select/creatable";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  tableCellClasses,
  Card,
  CardContent,
  FormGroup,
  IconButton,
  AppBar,
  Toolbar,
  Icon,
  Radio,
  Alert,
  StepButton,
  MenuItem,
  Stack,
  Switch,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import moment from "moment";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";

import FormPageHeader from "../../utilities/FormPageHeader";
import jwtDecode from "jwt-decode";
import OrderSuccess from "./OrderSuccess";
import ProjectOverview from "./ProjectOverview";

import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import {
  clearOrderFormData,
  setHasBack,
  setHasBackOrderForm,
  clearRowDataValue,
  clearStepData,
} from "app/store/projectSlice";
import { set } from "lodash";

const ColorButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.secondary.contrastText} !important`,
  backgroundColor: theme.palette.secondary.main,
  padding: "5px 15px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "block",
  textAlign: "center",
  position: "relative",
  fontSize: "12px",
  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },

  "&[disabled]": {
    opacity: 0.4,
    background: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
    "& .file": {
      cursor: "not-allowed",
    },
  },

  "& .file": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    cursor: "pointer",
  },
}));

const newOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newCustomerOrder}`;
const hubSpotDealsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getallhubspotdeals}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const searchProjectUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.searchProjectName}`;
const draftProjectByRoleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.draftProjectByRole}`;
const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRanges}`;
const colorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllHandlesByVendor}`;
const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllCarcassByVendor}`;

import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { useEffectEvent } from "react";

const ModalToast = ({ message, show }) => {
  const theme = useTheme();

  if (!show) return null;

  return (
    <div className="absolute top-6 left-1/2 transform -translate-x-1/2 z-50 transition-opacity duration-500">
      <div
        className="flex items-center px-8 py-6 rounded-lg shadow-lg max-w-xs w-full opacity-100"
        style={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          border: `4px solid ${theme.palette.error.main}`,
        }}
      >
        <ErrorOutlineOutlinedIcon
          sx={{
            color: theme.palette.error.main,
            mr: 1.5,
            fontSize: "1.25rem",
          }}
        />

        <span className="text-md">{message}</span>
      </div>
    </div>
  );
};

const docTypeOptions = [
  { value: "SO", label: "SO" },
  { value: "AO", label: "AO" },
];

const SpecialProjectOrder = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), {
      noSsr: true,
    });
  const { mode } = props;
  // const [activeStep, setActiveStep] = useState(0);
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [openSuccessOrder, setOpenSuccessOrder] = useState(false);
  const [projectOverviewOpen, setProjectOverviewOpen] = useState(false);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const navigate = useNavigate();
  const [orderCategoryValue, setOrderCategoryValue] = useState();
  const [qtyValue, setQtyValue] = useState(1);
  const [rowData, setRowData] = useState([]);
  const [phasesRowData, setPhasesRowData] = useState([]);
  const [typeRowData, setTypeRowData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(1);
  const gridRef = useRef();
  const phaseGridRef = useRef();
  const typeGridRef = useRef();
  const hiddenExcelFile = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [selectedQty, setSelectedQty] = useState("");
  const [selectedPhases, setSelectedPhases] = useState("");
  const [typesPhaseQty, setTypesPhaseQty] = useState("");
  const [showType, setShowType] = useState(false);
  const [showProjectTypeQty, setShowProjectTypeQty] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [phaseNameCode, setPhaseNameCode] = useState("");
  const [phasesTotalValue, setPhasesTotalValue] = useState(0);
  const [typeTotalValue, setTypeTotalValue] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showPhasesAlert, setShowPhasesAlert] = useState(false);
  const [InitialPhaseQty, setInitialPhaseQty] = useState("");
  const [initialQty, setInitialQty] = useState("");
  const [initialRowData, setInitialRowData] = useState("");
  const [newPhases, setNewPhase] = useState("");
  const [newQty, setNewQty] = useState("");
  const [apiProjectTypes, setApiProjectTypes] = useState([]);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [excelProgress, setExcelProgress] = useState(0);
  const [formValues, setFormValues] = useState([
    {
      range: {},
      priceGroup: {},
      color: {},
      carcass: {},
      handle: {},
    },
  ]);
  const [uploadValue, setUploadValue] = useState([{ uploadFile: null }]);

  const [error, setError] = useState();
  const [checksubmit, setCheckSubmit] = useState(false);
  const [validError, setValidError] = useState({});
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [customerId, setCustomerId] = useState();
  const [currentOrder, setCurrentOrder] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [showroom, setShowroom] = useState(null);
  const [product, setProduct] = useState();
  const [draftOrder, setDraftOrder] = useState();
  const [orderReference, setOrderReference] = useState("");
  const [prjOrderReference, setPrjOrderReference] = useState("");
  const [typeNumber, setTypeNumber] = useState("");
  const [uniqueID, setUniqueID] = useState("");
  const [clientName, setClientName] = useState("");
  const [commissionName, setCommissionName] = useState();
  const [WG1Price, setWG1Price] = useState("");
  const [WG2Price, setWG2Price] = useState("");
  const [count, setCount] = useState(0);
  const [volume, setVolume] = useState();
  const [weight, setWeight] = useState();
  const [docType, setDocType] = useState(docTypeOptions[0]);
  const [containerNo, setContainerNo] = useState();
  const [loadingWeek, setLoadingWeek] = useState();
  const [freight, setFreight] = useState();
  const [comment, setComment] = useState();
  const [discountChecked, setDiscountChecked] = useState(false);
  const [showroomOptions, setShowroomOptions] = useState([]);
  const [loadingWeekOptions, setLoadingWeekOptions] = useState([]);
  const [newOrderData, setNewOrderData] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [freightOptions, setFreightOptions] = useState([]);
  const [orderCategoryOptions, setOrderCategoryOptions] = useState([]);
  const [hubSpot, setHubSpot] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [SDFile, setSDFile] = useState(null);
  const [DRWFile, setDRWFile] = useState(null);
  const [sdFileId, setSdFileId] = useState("");
  const [drwFileId, setDrwFileId] = useState("");
  const [appliancesDetailFileId, setAppliancesDetailFileId] = useState("");
  const [orderCheckFileId, setOrderCheckFileId] = useState("");
  const [appliancesDetail, setAppliancesDetail] = useState(null);
  const [orderCheckFile, setOrderCheckFile] = useState(null);
  const [drawingFile, setDrawingFile] = useState(null);
  const [sharedLater, setSharedLater] = useState(false);
  const [notApplicable, setNotApplicable] = useState(false);
  const [drwFileSupersedes, setDrwFileSupersedes] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(true);
  const [foreCastProduct, setForeCastProduct] = useState(null);
  const [draftOrderOptions, setDraftOrderOptions] = useState([]);
  const [draftList, setDraftList] = useState();
  const [selectedDraftOrder, setSelectedDraftOrder] = useState();
  const [isDraftOrder, setIsDraftOrder] = useState(false);
  const [selectedDeal, setSelectedDeal] = useState(null);

  const [costOfHubSpot, setCostOfHubSpot] = useState(0);
  const [hubSpotReference, setHubSpotReference] = useState("");
  const [defaultProductOption, setDefaultProductOption] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const dispatch = useDispatch();

  const [projectOptions, setProjectOptions] = useState([]);
  const [existingProjectOptions, setExistingProjectOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedProName, setSelectedProName] = useState(null);
  const [currentQuery, setCurrentQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [isSectionVisible, setIsSectionVisible] = useState(false);
  const [draftId, setDraftId] = useState();
  const [editPhases, setEditPhases] = useState(false);
  const [steps, setSteps] = useState();
  const [range, setRange] = useState([]);
  const [color, setColor] = useState([]);
  const [priceGroup, setPriceGroup] = useState([]);
  const [handles, setHandles] = useState([]);
  const [carcass, setCarcass] = useState([]);
  const [originalQty, setOriginalQty] = useState(null);
  const [prjOrderChanged, setPrjOrderChange] = useState(false);
  const [placeOrderBtnDisable, setPlaceOrderBtnDisable] = useState(false);
  const [originalPhasesRowData, setOriginalPhasesRowData] = useState([]);
  const TOTAL_MAX_LENGTH = 21;

  const pageSize = 30;

  const hasBackForm = useSelector((state) => state.project.hasBackOrderForm);
  const orderFormData = useSelector((state) => state.project.orderFormData);
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const KEY_BACKSPACE = "Backspace";
  const KEY_F2 = "F2";
  const KEY_ENTER = "Enter";
  const KEY_TAB = "Tab";
  const TOTAL_LENGTH = 22;
  const maxUniqueIdLength =
    TOTAL_LENGTH - clientName.length > 0 ? TOTAL_LENGTH - clientName.length : 0;

  const maxClientNameLength =
    TOTAL_LENGTH - uniqueID.length > 0 ? TOTAL_LENGTH - uniqueID.length : 0;
  const NumericEditor = memo(
    forwardRef((props, ref) => {
      const createInitialState = () => {
        let startValue;
        let highlightAllOnFocus = true;
        const eventKey = props.eventKey;

        if (eventKey === KEY_BACKSPACE) {
          // if backspace or delete pressed, we clear the cell
          startValue = "";
        } else if (eventKey && eventKey.length === 1) {
          // if a letter was pressed, we start with the letter
          startValue = eventKey;
          highlightAllOnFocus = false;
        } else {
          // otherwise we start with the current value
          startValue = props.value;
          if (props.eventKey === KEY_F2) {
            highlightAllOnFocus = false;
          }
        }

        return {
          value: startValue,
          highlightAllOnFocus,
        };
      };

      const initialState = createInitialState();
      const [value, setValue] = useState(initialState.value);
      const [highlightAllOnFocus, setHighlightAllOnFocus] = useState(
        initialState.highlightAllOnFocus,
      );
      const refInput = useRef(null);

      // focus on the input
      useEffect(() => {
        // get ref from React component
        const eInput = refInput.current;
        eInput.focus();
        if (highlightAllOnFocus) {
          eInput.select();

          setHighlightAllOnFocus(false);
        } else {
          // when we started editing, we want the caret at the end, not the start.
          // this comes into play in two scenarios:
          //   a) when user hits F2
          //   b) when user hits a printable character
          const length = eInput.value ? eInput.value.length : 0;
          if (length > 0) {
            eInput.setSelectionRange(length, length);
          }
        }
      }, []);

      /* Utility Methods */
      const cancelBeforeStart =
        props.eventKey &&
        props.eventKey.length === 1 &&
        "1234567890".indexOf(props.eventKey) < 0;

      const isLeftOrRight = (event) => {
        return ["ArrowLeft", "ArrowLeft"].indexOf(event.key) > -1;
      };

      const isCharNumeric = (charStr) => {
        return !!/\d/.test(charStr);
      };

      const isNumericKey = (event) => {
        const charStr = event.key;
        return isCharNumeric(charStr);
      };

      const isBackspace = (event) => {
        return event.key === KEY_BACKSPACE;
      };

      const finishedEditingPressed = (event) => {
        const key = event.key;
        return key === KEY_ENTER || key === KEY_TAB;
      };

      const onKeyDown = (event) => {
        if (isLeftOrRight(event) || isBackspace(event)) {
          event.stopPropagation();
          return;
        }

        if (!finishedEditingPressed(event) && !isNumericKey(event)) {
          if (event.preventDefault) event.preventDefault();
        }

        if (finishedEditingPressed(event)) {
          props.stopEditing();
        }
      };

      /* Component Editor Lifecycle methods */
      useImperativeHandle(ref, () => {
        return {
          // the final value to send to the grid, on completion of editing
          getValue() {
            return value === "" || value == null ? null : parseInt(value);
          },

          // Gets called once before editing starts, to give editor a chance to
          // cancel the editing before it even starts.
          isCancelBeforeStart() {
            return cancelBeforeStart;
          },

          // Gets called once when editing is finished (eg if Enter is pressed).
          // If you return true, then the result of the edit will be ignored.
          isCancelAfterEnd() {
            // will reject the number if it greater than 1,000,000
            // not very practical, but demonstrates the method.
            const finalValue = this.getValue();
            return finalValue != null && finalValue > 1000000;
          },
        };
      });

      return (
        <input
          ref={refInput}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onKeyDown={(event) => onKeyDown(event)}
          className="numeric-input"
        />
      );
    }),
  );
  const getRangeList = async () => {
    OAuthService.getList(`${rangeUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const ranges = list.data;
        setRange(
          ranges?.map((range) => ({
            value: range?.productId,
            label: `${range?.priceGroup?.pgId || "NA"}-${range?.productName}`,
            name: range?.productName,
            id: range.id,
            priceGroup: range?.priceGroup?.pgId,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };

  const getHandleList = async () => {
    OAuthService.getList(`${handleUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { handles } = list.data?._embedded;
        setHandles(
          handles?.map((handle) => ({
            value: handle.productId,
            label: `${handle.productId}-${handle.productName}`,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };

  const getCarcassList = async () => {
    OAuthService.getList(`${carcassUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { carcasses } = list.data?._embedded;
        setCarcass(
          carcasses?.map((carcasse) => ({
            value: carcasse.productId,
            label: `${carcasse.productId}-${carcasse.productName}`,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };
  useEffect(() => {
    if (product?.id) {
      getRangeList();
      getHandleList();
      getCarcassList();
    }
  }, [product]);
  const CustomTextEditorPhaseName = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value || "");

    const handleChange = (event) => {
      setValue(event.target.value);
    };

    useImperativeHandle(ref, () => ({
      getValue: () => {
        const validationValue = value.toUpperCase();

        if (validationValue.trim() === "") {
          setToastMessage("Phase Name cannot be empty or spaces only!");
          setShowToast(true);
          setTimeout(() => setShowToast(false), 5000);
          return props.value; // reject — keep old value
        }

        const specialCharRegex = /^[A-Z0-9()_\- ]*$/;
        if (!specialCharRegex.test(validationValue)) {
          setToastMessage("Special characters are not allowed!");
          setShowToast(true);
          setTimeout(() => setShowToast(false), 5000);
          return props.value;
        }

        return validationValue.trim();
      },
    }));

    return (
      <input
        type="text"
        value={value}
        onChange={handleChange}
        autoFocus
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
          textTransform: "uppercase",
          backgroundColor: "transparent",
          color: "inherit",
        }}
      />
    );
  });
  const normalizeExcelValue = (value) => {
    if (value === null || value === undefined) return "";

    return String(value).trim().toUpperCase();
  };
  const normalizeHeaders = (data) => {
    return data.map((row) => {
      const newRow = {};
      Object.keys(row).forEach((key) => {
        newRow[key.trim().toUpperCase()] = row[key];
      });
      return newRow;
    });
  };
  const normalizeExcelNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;

    let cleaned = String(value);

    cleaned = cleaned.replace(/[^0-9.-]/g, "");

    const num = parseFloat(cleaned);

    return isNaN(num) ? 0 : num;
  };
  const findRangeMatch = (excelRange) => {
    if (!excelRange) return null;

    return range.find(
      (r) => r.name?.toUpperCase() === excelRange.toUpperCase(),
    );
  };

  const findHandleMatch = (excelHandle) => {
    if (!excelHandle) return null;

    return handles.find(
      (h) => h.value?.toUpperCase() === excelHandle.toUpperCase(),
    );
  };

  const findCarcassMatch = (excelCarcass) => {
    if (!excelCarcass) return null;

    return carcass.find(
      (c) => c.value?.toUpperCase() === excelCarcass.toUpperCase(),
    );
  };
  const colorCache = {};

  const getColorsForRange = async (rangeId) => {
    if (colorCache[rangeId]) {
      return colorCache[rangeId];
    }

    const res = await OAuthService.getList(`${colorUrl}/${rangeId}/variations`);

    const variations = res.data?._embedded?.rangeVariations || [];

    const colors = variations.map((v) => ({
      value: v.productId,
      label: `${v.productId}-${v.productName}`,
    }));

    colorCache[rangeId] = colors;

    return colors;
  };
  const mapMaterialColumns = async (row, index) => {
    const emptyResult = {
      [`range${index}Id`]: "",
      [`range${index}`]: "",
      [`priceGroup${index}`]: "",
      [`color${index}Id`]: "",
      [`color${index}`]: "",
      [`carcass${index}Id`]: "",
      [`carcass${index}`]: "",
      [`handle${index}Id`]: "",
      [`handle${index}`]: "",
      [`materialError${index}`]: false,
    };

    let isInvalidRow = false;
    const result = {};

    const rangeExcel = normalizeExcelValue(row[`RANGE ${index}`]);
    const colorExcel = normalizeExcelValue(row[`FRONT COLOR ${index}`]);
    const carcassExcel = normalizeExcelValue(row[`CARCASS ${index}`]);
    const handleExcel = normalizeExcelValue(row[`HANDLE ${index}`]);

    let rangeMatch = null;
    let colorMatch = null;
    let carcassMatch = null;
    let handleMatch = null;

    if (rangeExcel) {
      rangeMatch = findRangeMatch(rangeExcel);
      if (!rangeMatch) isInvalidRow = true;
    }

    if (colorExcel && rangeMatch) {
      const colors = await getColorsForRange(rangeMatch.id);
      colorMatch = colors.find(
        (c) => c.value?.toUpperCase() === colorExcel.toUpperCase(),
      );
      if (!colorMatch) isInvalidRow = true;
    } else if (colorExcel && !rangeMatch) {
      isInvalidRow = true;
    }

    if (carcassExcel) {
      carcassMatch = findCarcassMatch(carcassExcel);
      if (!carcassMatch) isInvalidRow = true;
    }

    if (handleExcel) {
      handleMatch = findHandleMatch(handleExcel);
      if (!handleMatch) isInvalidRow = true;
    }

    if (isInvalidRow) {
      return {
        ...emptyResult,
        [`materialError${index}`]: true,
      };
    }

    if (rangeMatch) {
      result[`range${index}Id`] = rangeMatch.value;
      result[`range${index}`] = rangeMatch.label;
      result[`priceGroup${index}`] = rangeMatch.priceGroup;
    }

    if (colorMatch) {
      result[`color${index}Id`] = colorMatch.value;
      result[`color${index}`] = colorMatch.label;
    }

    if (carcassMatch) {
      result[`carcass${index}Id`] = carcassMatch.value;
      result[`carcass${index}`] = carcassMatch.label;
    }

    if (handleMatch) {
      result[`handle${index}Id`] = handleMatch.value;
      result[`handle${index}`] = handleMatch.label;
    }

    return {
      ...emptyResult,
      ...result,
      [`materialError${index}`]: false,
    };
  };
  const handleTypeExcelUpload = (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    setLoadingExcel(true);
    const reader = new FileReader();
    reader.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100);
        setExcelProgress(percent);
      }
    };

    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const masterSheetName = workbook.SheetNames.find((name) =>
          name.toLowerCase().includes("master"),
        );

        if (!masterSheetName) {
          setToastMessage(`No sheet found with name containing 'Master'`);
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
          hiddenExcelFile.current.value = null;
          setLoadingExcel(false);
          setExcelProgress(0);
          return;
        }

        const worksheet = workbook.Sheets[masterSheetName];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          raw: false,
          defval: "",
        });
        let normalizedData = normalizeHeaders(jsonData);
        const headers = Object.keys(normalizedData[0] || {});

        const requiredHeaders = [
          "TYPE",
          "UNIQUE ID",
          "LP WG1",
          "LP WG2",
          "VOLUME",
        ];

        const missingHeaders = requiredHeaders.filter(
          (h) => !headers.includes(h),
        );

        if (missingHeaders.length > 0) {
          setToastMessage(
            `Missing required columns: ${missingHeaders.join(", ")}`,
          );
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
          hiddenExcelFile.current.value = null;
          setLoadingExcel(false);
          setExcelProgress(0);
          return;
        }
        const validRows = normalizedData.filter(
          (row) =>
            normalizeExcelValue(row["TYPE"]) &&
            normalizeExcelValue(row["UNIQUE ID"]),
        );
        const typeTotalValue = selectedRows?.[0]?.phaseViseQty;
        if (validRows.length !== typeTotalValue) {
          setToastMessage(
            `Type details row count (${validRows.length}) does not match expected quantity (${typeTotalValue}).`,
          );
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
          hiddenExcelFile.current.value = null;
          setLoadingExcel(false);
          setExcelProgress(0);
          return;
        }
        const hasWeightColumn = Object.keys(normalizedData[0] || {}).includes(
          "WEIGHT",
        );
        const seen = new Set();
        const specialCharRegex = /^[A-Z0-9()_\- ]*$/;
        const maxCombinedLength = 20 - displayName.length;
        for (let i = 0; i < normalizedData.length; i++) {
          const type = normalizeExcelValue(normalizedData[i]["TYPE"]);
          const uid = normalizeExcelValue(normalizedData[i]["UNIQUE ID"]);

          if (!type || !uid) continue;
          const wg1 = normalizeExcelValue(normalizedData[i]["LP WG1"]);
          const wg2 = normalizeExcelValue(normalizedData[i]["LP WG2"]);
          const volume = normalizeExcelValue(normalizedData[i]["VOLUME"]);
          const weight = normalizeExcelValue(normalizedData[i]["WEIGHT"]);

          // Negative value validation
          const numericFields = [
            { name: "LP WG1", value: wg1 },
            { name: "LP WG2", value: wg2 },
            { name: "VOLUME", value: volume },
            { name: "WEIGHT", value: weight },
          ];

          const negativeField = numericFields.find((field) => {
            const value = String(field.value).trim();

            return value !== "" && Number(value) < 0;
          });

          if (negativeField) {
            setToastMessage(
              `${negativeField.name} cannot contain negative values. Please check Excel.`,
            );
            setShowToast(true);

            setTimeout(() => setShowToast(false), 3000);

            hiddenExcelFile.current.value = null;
            setLoadingExcel(false);
            setExcelProgress(0);

            return;
          }

          if (wg1 === "" || wg2 === "" || volume === "") {
            setToastMessage(
              `LP WG1, LP WG2 and VOLUME are mandatory. Please check Excel .`,
            );
            setShowToast(true);
            setTimeout(() => setShowToast(false), 3000);
            hiddenExcelFile.current.value = null;
            setLoadingExcel(false);
            setExcelProgress(0);
            return;
          }
          // Character validation
          if (!specialCharRegex.test(type) || !specialCharRegex.test(uid)) {
            setToastMessage(
              `Invalid characters in TYPE or UNIQUE ID at Excel.`,
            );
            setShowToast(true);
            setTimeout(() => setShowToast(false), 3000);
            hiddenExcelFile.current.value = null;
            setLoadingExcel(false);
            setExcelProgress(0);
            return;
          }

          //Slash validation
          if (
            type.includes("/") ||
            type.includes("\\") ||
            uid.includes("/") ||
            uid.includes("\\")
          ) {
            setToastMessage(
              `TYPE and UNIQUE ID must not contain '/' or '\\' .`,
            );
            setShowToast(true);
            setTimeout(() => setShowToast(false), 3000);
            hiddenExcelFile.current.value = null;
            setLoadingExcel(false);
            setExcelProgress(0);
            return;
          }

          //  Combined length validation
          if (type.length + uid.length > maxCombinedLength) {
            setToastMessage(
              `TYPE + UNIQUE ID length must be ≤ ${maxCombinedLength} .`,
            );
            setShowToast(true);
            setTimeout(() => setShowToast(false), 3000);
            hiddenExcelFile.current.value = null;
            setLoadingExcel(false);
            setExcelProgress(0);
            return;
          }

          const key = `${type}_${uid}`;

          if (seen.has(key)) {
            setToastMessage(
              `Duplicate Unique ID '${uid}' inside Type '${type}' .`,
            );
            setShowToast(true);
            setTimeout(() => setShowToast(false), 3000);
            hiddenExcelFile.current.value = null;
            setLoadingExcel(false);
            setExcelProgress(0);
            return;
          }

          seen.add(key);
        }

        const groupedTypes = {};

        normalizedData.forEach((row) => {
          const type = normalizeExcelValue(row["TYPE"]);
          const uid = normalizeExcelValue(row["UNIQUE ID"]);

          if (!type || !uid) return;

          const wg1 = normalizeExcelNumber(row["LP WG1"]) || 0;
          const wg2 = normalizeExcelNumber(row["LP WG2"]) || 0;
          const volume = normalizeExcelNumber(row["VOLUME"]) || 0;
          const weight = hasWeightColumn
            ? normalizeExcelNumber(row["WEIGHT"]) || 0
            : 0;

          if (!groupedTypes[type]) {
            groupedTypes[type] = [];
          }

          groupedTypes[type].push({
            uid,
            wg1,
            wg2,
            volume,
            weight,
          });
        });

        let runningCount = count;

        const projectTypeInfo = await Promise.all(
          Object.keys(groupedTypes).map(async (typeName) => {
            runningCount += 1;

            const sequence =
              orderReference?.length === 6
                ? runningCount.toString().padStart(2, "0")
                : runningCount.toString().padStart(3, "0");
            const orderRefWithSeq = `${orderReference}${sequence}`;

            const rows = groupedTypes[typeName];
            const excelRow = normalizedData.find(
              (r) => normalizeExcelValue(r["TYPE"]) === typeName,
            );
            const { wg1, wg2, volume, weight } = rows[0];
            const material1 = await mapMaterialColumns(excelRow, 1);
            const material2 = await mapMaterialColumns(excelRow, 2);
            const material3 = await mapMaterialColumns(excelRow, 3);
            const isMaterialInvalid = material1.materialError1;
            const orderList = rows.map((item, i) => ({
              uniqId: item.uid,
              commissionName:
                orderReference?.length === 6
                  ? `${orderRefWithSeq}-${product?.value}-${typeName}-${displayName}-${item.uid}`
                  : `${orderRefWithSeq}${product?.value}-${typeName}-${displayName}-${item.uid}`,
            }));

            return {
              vendorId: product?.id,
              vendor: product?.label,
              projectTypeNum: Number(sequence),
              typeName,
              wg1,
              wg2,
              volume,
              weight,
              ...material1,
              ...material2,
              ...material3,
              isMaterialInvalid,
              isSpecialDiscount: false,
              loadingWeek: "CURRENT",
              freightId: freight?.id,
              freight: freight?.value,
              specialComments: "",
              sharedLater: "",
              na: "",
              drawFileSupersedes: "",
              drwFile: "",
              applianceDetail: "",
              orderCheckList: "",
              drawingFile: [],
              orderList,
            };
          }),
        );
        const filterCurrentPhase = phasesRowData.map((row) => {
          const weekString = row.expectedProductionWeek;
          const week =
            weekString && typeof weekString === "string"
              ? weekString.split("/")[0]
              : weekString;
          const isCurrentPhase =
            selectedRows[0] && row.phaseName === selectedRows[0].phaseName
              ? true
              : false;
          const orderPlaced = row?.orderPlaced || false;

          // Base object
          let result = {
            id: row.id,
            phaseName: row.phaseName,
            qty: row.phaseViseQty,
            year: row.year,
            expectedProductionWeek: Number(week),
            phaseViseQty: row.phaseViseQty,
            isCurrentPhase,
          };

          if (!orderPlaced && isCurrentPhase) {
            const typeViseQty = {};

            Object.keys(groupedTypes).forEach((type) => {
              typeViseQty[type.toUpperCase()] = groupedTypes[type].length;
            });

            result = { ...result, typeViseQty };
          } else if (orderPlaced && !isCurrentPhase) {
            const typeViseQty = row?.typeViseQty || {};
            result = { ...result, typeViseQty };
          }
          return result;
        });

        const payload = {
          customerId: hasSupperUser ? selectedPartner?.value : customerId,
          showroomId: showroom.value,
          orderCategory: orderCategoryValue?.value,
          docType: "SO",
          orderRef: orderReference,
          projectTypeInfo: projectTypeInfo,
          overallQty: selectedQty,
          projectDisplayName: displayName,
          phasesInfo: filterCurrentPhase,
          currentPhaseId: selectedRows[0].id,
          // containerNo: containerNo,
          customerProjectNum: 0,
          //projectForecastId: selectedProName.id,
          // projectTypeNum: 0,
          // projectNum: "string",
          projectName: selectedProName.label,
        };
        setLoadingExcel(false);
        setExcelProgress(0);
        navigate("/order/special-project-order-summary", {
          state: {
            payload,
            product,
          },
        });
      } catch (error) {
        console.error(error);
        setLoadingExcel(false);
        setExcelProgress(0);
      }
    };

    reader.readAsArrayBuffer(fileUploaded);
  };

  const ExpectWeekEditor = forwardRef((props, ref) => {
    const getWeekUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getWeek}`;

    const [selectedWeek, setSelectedWeek] = useState(null);
    const [weekOption, setWeekOption] = useState([]);
    const [actualLoadingDate, setActualLoadingDate] = useState(
      moment().add(7, "weeks").format("YYYY-MM-DD"), // Default to current date + 7 weeks
    );
    useEffect(() => {
      const getLoadingWeekList = async () => {
        try {
          const list = await OAuthService.getList(
            `${getWeekUrl}?date=${actualLoadingDate}`,
          );
          const week = list.data;

          if (week) {
            let defaultWeek = week;
            const generateDateStrings = (startYear) => {
              const result = [];
              let weeks = defaultWeek;
              for (let year = startYear; year <= startYear + 4; year++) {
                if (year === startYear) {
                  weeks = defaultWeek;
                } else {
                  weeks = 1;
                }
                for (; weeks <= 52; weeks++) {
                  result.push({
                    value: weeks,
                    label: `${weeks}/${year}`,
                    year,
                  });
                }
              }
              return result;
            };

            const currentYear = moment().add(7, "weeks").year();
            const weekOptions = generateDateStrings(currentYear);
            setWeekOption(weekOptions);
          }
        } catch (error) {
          console.error("Error fetching loading weeks", error);
        }
      };

      getLoadingWeekList();
    }, [actualLoadingDate]);

    const handleChangeWeek = (option) => {
      setSelectedWeek(option);

      if (props.node && props.node.data) {
        props.node.setDataValue("year", option.year);
      }
    };

    useImperativeHandle(ref, () => ({
      getValue() {
        return selectedWeek?.label || "";
      },
    }));

    return (
      <Box className="flex">
        <Select
          value={selectedWeek}
          options={weekOption}
          onChange={handleChangeWeek}
          styles={customStyles()}
          className="w-full"
          menuPlacement="auto"
          menuPosition="fixed"
        />
      </Box>
    );
  });

  const CustomTextEditorType = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value || "");

    const handleChange = (event) => {
      let newValue = event.target.value.toUpperCase();

      if (newValue.trim() === "") {
        setToastMessage("Type Name cannot be empty or spaces only!");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        setValue("");
        return;
      }

      const specialCharRegex = /^[A-Z0-9()_\- ]*$/;
      if (!specialCharRegex.test(newValue)) {
        setToastMessage("Special characters are not allowed!");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        return;
      }

      if (newValue.includes("/") || newValue.includes("\\")) {
        setToastMessage("Type Name must not contain '/' or '\\'.");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        return;
      }

      setValue(newValue);
    };

    useImperativeHandle(ref, () => ({
      getValue: () => value.trim(),
    }));

    return (
      <input
        type="text"
        value={value}
        onChange={handleChange}
        autoFocus
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          color: "inherit",
        }}
      />
    );
  });

  const phasesColumnDefs = useMemo(
    () => [
      {
        field: "id",
        headerName: "Sno.",
        valueGetter: "node.rowIndex + 1",
        maxWidth: 70,
      },
      {
        field: "phaseName",
        editable: (params) => !params.data.orderPlaced,
        cellEditor: CustomTextEditorPhaseName,
        valueFormatter: (params) =>
          params.value ? params.value.toUpperCase() : "",
        processCellFromClipboard: (params) => {
          const raw = params.value ? String(params.value).trim() : "";
          if (raw === "") {
            setToastMessage("Phase Name cannot be empty!");
            setShowToast(true);
            setTimeout(() => setShowToast(false), 5000);
            return params.node.data.phaseName || "";
          }
          return raw.toUpperCase();
        },
      },
      {
        field: "qty",
        headerName: "Qty/Phase",
        maxWidth: 100,
        cellEditor: NumericEditor,
        hide: true,
      },
      {
        field: "phaseViseQty",
        headerName: "Qty/Phase",
        maxWidth: 100,
        editable: (params) => !params.data.orderPlaced,
        cellEditor: NumericEditor,
        valueParser: (params) => {
          const newValue = parseFloat(params.newValue);
          return isNaN(newValue) || newValue < 0 ? null : newValue;
        },

        processCellFromClipboard: (params) => {
          const value = parseFloat(params.value);
          return isNaN(value) || value < 0 ? null : value;
        },
      },
      {
        field: "expectedProductionWeek",
        headerName: "Expected Week",
        editable: (params) => !params.data.orderPlaced,
        cellEditorPopup: true,
        cellEditor: ExpectWeekEditor,
        suppressKeyboardEvent: (params) => {
          const { event } = params;

          return (
            (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "v"
          );
        },
      },
      {
        field: "year",
        headerName: "Year",
        editable: false,
      },
    ],
    [product],
  );

  const CustomTextEditor = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value || "");

    const handleChange = (event) => {
      const newValue = event.target.value.toUpperCase();
      setValue(newValue);
    };

    useImperativeHandle(ref, () => ({
      getValue: () => {
        if (value.trim() === "") {
          toast.warning("Unique ID cannot be empty or spaces only!");
          return props.value;
        }

        const specialCharRegex = /^[A-Z0-9()_\- ]*$/;
        if (!specialCharRegex.test(value)) {
          toast.warning("Special characters are not allowed!");
          return props.value;
        }

        if (value.includes("/") || value.includes("\\")) {
          toast.warning("Unique ID must not contain '/' or '\\'.");
          return props.value;
        }

        return value.trim();
      },
    }));

    return (
      <input
        type="text"
        value={value}
        onChange={handleChange}
        autoFocus
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          color: "inherit",
        }}
      />
    );
  });

  const onGridReadyPhaseGrid = (params) => {
    const { api } = params;
    // When grid is ready, select the first row where orderPlaced is false.
    if (phasesRowData.length > 0) {
      let firstSelectableIndex = -1;
      for (let i = 0; i < phasesRowData.length; i++) {
        if (!phasesRowData[i].orderPlaced) {
          firstSelectableIndex = i;
          break;
        }
      }
      if (firstSelectableIndex !== -1) {
        api.forEachNode((node) => {
          if (node.rowIndex === firstSelectableIndex) {
            node.setSelected(true);
            api.ensureIndexVisible(firstSelectableIndex);
          }
        });
        setSelectedRows(api.getSelectedRows());
      }
    }
  };

  const onSelectionChanged = (params) => {
    const api = params.api;
    let selectedRow = api.getSelectedRows()[0];
    let selectedNode = api.getSelectedNodes()[0];

    setSelectedRows(api.getSelectedRows());

    setShowAlert(false);

    if (selectedNode) {
      setPhaseNameCode(
        `P${(selectedNode.rowIndex + 1).toString().padStart(2, "0")}`,
      );
    } else {
      setPhaseNameCode("");
    }

    let firstSelectableIndex = -1;
    for (let i = 0; i < phasesRowData.length; i++) {
      if (!phasesRowData[i].orderPlaced) {
        firstSelectableIndex = i;
        break;
      }
    }
    if (firstSelectableIndex !== -1) {
      if (
        !selectedNode ||
        selectedNode.rowIndex !== firstSelectableIndex ||
        selectedNode.data.orderPlaced === true
      ) {
        api.deselectAll();
        api.getRowNode(firstSelectableIndex).setSelected(true);
      }
    }

    selectedRow = api.getSelectedRows()[0];
    if (selectedRow) {
      setTypeTotalValue(selectedRow.phaseViseQty);
    }
    // setTypeTotalValue(selectedRow.phaseViseQty);
    setIsSubmitEnabled(
      !selectedRow ||
        !displayName ||
        !typesPhaseQty ||
        typeTotalValue !== selectedRow?.phaseViseQty,
    );
  };
  useEffect(() => {
    if (phasesRowData) {
      const allRowsValid = phasesRowData?.every(
        (row) =>
          row?.phaseViseQty > 0 &&
          row.expectedProductionWeek !== null &&
          row.expectedProductionWeek !== "",
      );

      setIsSubmitEnabled(!allRowsValid);
    }
  }, [phasesRowData]);

  const hasSupperUser = [
    "ROLE_ADMIN",
    "ROLE_MD",
    "ROLE_ORDERPRO",
    "ROLE_SOPDIR",
  ].some((role) => {
    if (token) {
      return token.scope.includes(role);
    }
  });
  const getNewOrder = async () => {
    let list;
    let newOrder = null;
    try {
      if (mode === "new") {
        if (hasSupperUser) {
          if (selectedPartner) {
            list = await OAuthService.getList(
              newOrderUrl + `?customerId=${selectedPartner?.value}`,
            );
            newOrder = list?.data;
          }
        } else {
          list = await OAuthService.getList(newOrderUrl);
          newOrder = list?.data;
        }

        if (newOrder) {
          const products = newOrder?.products.map((value) => {
            return {
              label: value.name,
              value: value.shortKey,
              id: value.id,
            };
          });

          const loadingWeek = Object.keys(newOrder?.loadingWeek).map((key) => ({
            value: key,
            label: newOrder.loadingWeek[key],
          }));
          const showrooms = Object.keys(newOrder?.showrooms).map((key) => ({
            value: key,
            label: newOrder.showrooms[key],
          }));

          const orderCategories = newOrder?.orderCategories
            ?.filter((value) => value.name === "PRJ" || value.name === "CPRJ")
            .map((value) => {
              return { label: value.displayName, value: value.name };
            });
          const freight = newOrder?.freightOptions.map((value) => {
            return {
              label: `${value.shippingMethodName}`,
              value: value.shippingMethodName,
              id: value.code,
            };
          });
          setShowroom({
            value: newOrder?.showroomId,
            label: newOrder?.showroomName,
          });
          setFreightOptions(freight);
          setOrderCategoryOptions(orderCategories);
          setProductOptions(products);
          setForeCastProduct(products);
          setDefaultProductOption(products);
          setLoadingWeekOptions(loadingWeek);
          setShowroomOptions(showrooms);
          setCustomerName(newOrder?.companyName);
          setCustomerId(newOrder?.partnerCompany);
          setOrderReference(newOrder?.projectNum);
          setTypeNumber(newOrder?.typeNumber);
          setUniqueID(newOrder?.uniqueId === null ? "" : newOrder?.uniqueId);
          setClientName(
            newOrder?.clientName === null ? "" : newOrder?.clientName,
          );
          setHubSpot(newOrder);
          setNewOrderData(newOrder);
        }
      }
    } catch (error) {
      console.log("error.message", error);
      toast.error(error.message);
    }
  };

  const getCustomer = async () => {
    const list = await OAuthService.getList(
      companiesUrl +
        `/search/findActiveByCustomerTypes?&customerTypes=REGULAR&customerTypes=WHOLESALE&page=0&sort=id,ase,&size=1000`,
    );
    let companies = list.data?._embedded?.companies;
    companies = companies.map((company) => {
      return {
        value: company.id,
        label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
      };
    });
    setCustomerOptions(companies);
    if (customerId) {
      const defaultCustomer = companies.find((item) => item.id === customerId);
      setCustomerName(defaultCustomer);
    }
  };

  const getShowroom = async () => {
    try {
      if (Number(customerName.value)) {
        const showroomByCompanyUrl = `${companiesUrl}/${customerName.value}/showrooms`;
        const list = await OAuthService.getList(showroomByCompanyUrl);
        let showrooms = list.data?._embedded?.showrooms;
        showrooms = showrooms.map((showroom) => {
          return {
            value: showroom.id,
            label: showroom.name,
          };
        });
        setShowroomOptions(showrooms);
      }
    } catch (error) {
      toast.error("Showroom data not available");
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (selectedPartner || !hasSupperUser || mode === "new") {
      getNewOrder();
    }
  }, [selectedPartner, hasSupperUser, mode]);
  useEffect(() => {
    if (orderCategoryValue?.value === "RET" && newOrderData.hubspotEnabled) {
      getHubSpotDeal();
    }
  }, [orderCategoryValue, newOrderData]);

  useEffect(() => {
    if (mode === "new") {
      setProduct();
      setOrderCategoryValue();
      setWG1Price("");
      setWG2Price("");
      setVolume("");
      setWeight("");
      setContainerNo("");
      setLoadingWeek();
      setFreight();
      setComment("");
      setSDFile("");
      setDRWFile("");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
    }
  }, [mode === "new"]);

  function isFirstColumn(params) {
    var displayedColumns = params?.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn =
      displayedColumns && displayedColumns[0] === params?.column;
    return thisIsFirstColumn;
  }

  const defaultColDef = useMemo((params) => {
    return {
      flex: 1,
      minWidth: 100,
      resizable: true,
      checkboxSelection: isFirstColumn,
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      cellRendererParams: {
        checkbox: true,
      },
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    dispatch(setHasBackOrderForm(false));
    setOrderReference(prjOrderReference);
    setOrderCategoryValue();
    setSelectedProName(null);
    setDraftOrderOptions([]);
    setDraftId();
    setDraftOrder("");
    setProduct(null);
    setSelectedQty("");
    setSelectedPhases("");
    setPhasesRowData([]);
    setDisplayName("");
    setPhaseNameCode("");
    setTypesPhaseQty("");
    setSelectedPartner(null);
    setShowroom(null);
    setOrderCategoryValue(null);
    setTypeNumber("");
    setCommissionName("");
    setShowroomOptions([]);
    setOrderCategoryOptions([]);
    setOrderReference("");
    setShowToast(false);
    setFreightOptions([]);
    //Partner admin account issue related while placing orders-order Reference empty
    if (!hasSupperUser) {
      getNewOrder();
    }
  };
  const handlePlaceOrder = () => {
    setOpen(true);
  };
  const handleChangeQty = (e) => {
    const value = Number(e.target.value);
    if (editPhases) {
      setNewQty(value - initialQty);
    }
    const isExisting = existingProjectOptions?.includes(selectedProName);

    if (hasSupperUser) {
      setSelectedQty(value);

      const totalPhaseQty = phasesRowData.reduce(
        (sum, row) => sum + Number(row.phaseViseQty || 0),
        0,
      );

      if (value !== totalPhaseQty) {
        setShowPhasesAlert(true);
        setToastMessage(
          "Please adjust phase quantities to match the total quantity",
        );
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
      } else {
        setShowPhasesAlert(false);
      }

      return;
    }

    if (isExisting && !hasSupperUser) {
      const maxAllowed = Math.floor(originalQty * 1.05);

      if (value < originalQty) {
        setSelectedQty(originalQty);
        setToastMessage(`You cannot reduce the overall quantity.`);
        setShowToast(true);
        return;
      }

      if (value > maxAllowed) {
        setSelectedQty(maxAllowed);
        setToastMessage(
          `Quantity cannot exceed +5%. Adjusted to ${maxAllowed}.`,
        );
        setShowToast(true);
      } else {
        setSelectedQty(value);
      }

      const totalPhaseQty = phasesRowData.reduce(
        (sum, row) => sum + Number(row.phaseViseQty || 0),
        0,
      );

      const effectiveQty = value > maxAllowed ? maxAllowed : value;

      if (effectiveQty !== totalPhaseQty) {
        setShowPhasesAlert(true);
        setToastMessage(
          "Please adjust phase quantities to match the total quantity",
        );
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
      } else {
        setShowPhasesAlert(false);
      }

      return;
    }

    setSelectedQty(value);

    const totalPhaseQty = phasesRowData.reduce(
      (sum, row) => sum + Number(row.phaseViseQty || 0),
      0,
    );

    if (value !== totalPhaseQty) {
      setShowPhasesAlert(true);
      setToastMessage(
        "Please adjust phase quantities to match the total quantity",
      );
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    } else {
      setShowPhasesAlert(false);
    }
  };
  const handleBlur = () => {
    if (selectedQty < 10) {
      setSelectedQty(10);
      setToastMessage("Project order minimum quantity is 10");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };
  const handleChangeOrderCategory = (event) => {
    if (!showroom?.label) {
      toast.warning("Please select showroom");
      return;
    }
    setOrderCategoryValue({
      value: event.value,
      label: event.label,
    });
    setProduct(null);
    setProductOptions(defaultProductOption);
    if (event.value === "RET") {
      setSelectedDeal(null);
    }
    if (event.value === "PRJ" || event.value === "CPRJ") {
      setPrjOrderReference(orderReference);
      // setOrderReference("");
    }
    if (event.value === "CPRJ") {
      setProduct(null);
      setSelectedPhases("");
      setSelectedQty("");
      setPhasesRowData([]);
      setRowData([]);
      setDisplayName("");
    }
  };
  useEffect(() => {
    if (
      orderCategoryValue &&
      (selectedPartner || customerName) &&
      showroom &&
      freight
    ) {
      setOpen(true);
    }
  }, [orderCategoryValue, selectedPartner, showroom, freight]);
  const fetchInitialOptions = async () => {
    try {
      const options = await getProjectName("", 0, pageSize);
      setExistingProjectOptions(options.projectOptions);
      setProjectOptions(options.projectOptions);
      setFilteredOptions(options.projectOptions);
    } catch (error) {
      toast.error("Failed to fetch project options.");
    }
  };

  const getProjectName = async (query, page, size) => {
    try {
      let url = searchProjectUrl;
      if (query) {
        url += `?companyId=${
          hasSupperUser ? selectedPartner?.value : customerId
        }&projectName=${query}&orderCategory=${
          orderCategoryValue?.value
        }&page=${page}&size=${size}`;
      } else {
        url += `?companyId=${
          hasSupperUser ? selectedPartner?.value : customerId
        }&orderCategory=${orderCategoryValue?.value}&page=${page}&size=${size}`;
      }

      const list = await OAuthService.getList(url);
      const data = list.data?.content || [];

      return {
        projectOptions: data.map((item) => ({
          value: item.id,
          label: item.projectName,
          phases: item.noOfPhases,
          quantity: item.totalQuantity,
          phasesData: item.projectPhases,
          vendor: item.vendor,
          vendorId: item.vendorId,
          orderReference: item.project,
          projectCode: item.clientName,
          types: item.types,
        })),
        hasMore: data.length >= size,
      };
    } catch (error) {
      toast.error(error.message);
      return { projectOptions: [], hasMore: false };
    }
  };
  const getDraftProjectList = async () => {
    try {
      let url =
        draftProjectByRoleUrl +
        `?customerId=${hasSupperUser ? selectedPartner?.value : customerId}`;

      const list = await OAuthService.getList(url);
      if (list?.data) {
        const filteredList = list.data.sort(
          (a, b) => new Date(b.lastModifiedDate) - new Date(a.lastModifiedDate),
        );
        setDraftList(filteredList);
        setDraftOrderOptions(
          filteredList.map((item) => ({
            value: item.projectName,
            label: item.projectName,
            id: item.id,
          })),
        );
      }
    } catch (error) {
      toast.error(error.message);
      return;
    }
  };
  const handleInputChange = (inputValue) => {
    setCurrentQuery(inputValue);

    if (inputValue) {
      const filtered = projectOptions.filter(
        (option) =>
          option.label &&
          option.label.toLowerCase().includes(inputValue.toLowerCase()),
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(projectOptions);
    }
  };
  const handleChangeProject = (newValue, action) => {
    if (action.action === "clear") {
      if (!existingProjectOptions?.includes(selectedProName)) {
        const labelToRemove = selectedProName.label.toLowerCase();
        setProjectOptions((prev) =>
          prev.filter((opt) => opt.label.toLowerCase() !== labelToRemove),
        );
        setFilteredOptions((prev) =>
          prev.filter((opt) => opt.label.toLowerCase() !== labelToRemove),
        );
      }
      phaseGridRef.current?.api?.deselectAll();
      setSelectedRows([]);
      setSelectedProName(null);
      setProduct(null);
      setSelectedPhases("");
      setSelectedQty("");
      setPhasesRowData([]);
      setDisplayName("");
      setPhaseNameCode("");
      setTypesPhaseQty("");
      setEditPhases(false);
      setOriginalQty("");
      setVolume("");
      setWeight("");
      setWG1Price("");
      setWG2Price("");
      setContainerNo("");
      setLoadingWeek(null);
      setComment("");
      setOrderReference("");
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
      setDRWFile("");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setSDFile("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setUploadValue([{ uploadFile: null }]);
      setShowPhasesAlert(false);
      setShowToast(false);
      dispatch(clearRowDataValue());
      dispatch(clearStepData());
      setPhasesTotalValue(0);
      setTypeTotalValue(0);

      return;
    }

    if (newValue?.__isNew__) {
      phaseGridRef.current?.api?.deselectAll();
      setSelectedRows([]);
      const normalizedValue = newValue.value.trim();
      const newOption = {
        value: normalizedValue,
        label: normalizedValue.toUpperCase(),
      };

      setSelectedProName(newOption);
      setProjectOptions((prev) => [...prev, newOption]);
      setFilteredOptions((prev) => [...prev, newOption]);
      setForeCastProduct(
        productOptions.map((item) => ({
          value: item.value,
          label: item.label,
          id: item.id,
        })),
      );
      setProduct(null);
      setSelectedPhases("");
      setSelectedQty("");
      setPhasesRowData([]);
      setRowData([]);
      setDisplayName("");
      setOrderReference(prjOrderReference);
      setCount(0);
      setShowType(false);
      setEditPhases(false);
      setOriginalQty("");
      setVolume("");
      setWeight("");
      setWG1Price("");
      setWG2Price("");
      setContainerNo("");
      setPhaseNameCode("");
      setLoadingWeek(null);
      setComment("");
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
      setDRWFile("");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setSDFile("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setUploadValue([{ uploadFile: null }]);
      setTypeRowData([]);
      setDraftId();
      setTypesPhaseQty("");
      setShowPhasesAlert(false);
      setShowToast(false);
      setPrjOrderChange(true);
      dispatch(setHasBack(false));
      dispatch(clearRowDataValue());
      dispatch(clearStepData());
      setPhasesTotalValue(0);
      setTypeTotalValue(0);
    } else {
      phaseGridRef.current?.api?.deselectAll();
      setSelectedRows([]);
      setPhaseNameCode("");
      setSelectedProName(newValue);

      setForeCastProduct(
        productOptions.map((item) => ({
          value: item.label,
          label: item.value,
          id: item.id,
        })),
      );
      setProduct({
        label: newValue?.vendor,
        id: newValue?.vendorId,
        value: newValue?.vendor
          .split(" ")
          .map((word) => word[0])
          .join(""),
      });
      setSelectedPhases(newValue?.phases || "");
      setInitialPhaseQty(newValue?.phases || "");
      setSelectedQty(newValue?.quantity || "");
      setInitialQty(newValue?.quantity || "");
      setPhasesRowData(
        newValue?.phasesData
          ? JSON.parse(JSON.stringify(newValue.phasesData))
          : [],
      );
      setInitialRowData(newValue?.phasesData || []);
      const clonedPhases = JSON.parse(
        JSON.stringify(newValue?.phasesData || []),
      );

      setOriginalPhasesRowData(clonedPhases);
      setPhasesTotalValue(newValue?.quantity || 0);
      setOrderReference(newValue?.orderReference || "");
      setCount(newValue?.types.length);
      setPhaseNameCode("");
      setTypesPhaseQty("");
      setRowData([]);
      setDisplayName(newValue?.projectCode || "");
      setEditPhases(false);
      setOriginalQty("");
      setVolume("");
      setWeight("");
      setWG1Price("");
      setWG2Price("");
      setContainerNo("");
      setLoadingWeek(null);
      setComment("");
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
      setDRWFile("");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setSDFile("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setUploadValue([{ uploadFile: null }]);
      setTypeRowData([]);
      setDraftId();
      setShowPhasesAlert(false);
      setShowToast(false);
      setPrjOrderChange(true);
      dispatch(setHasBack(false));
      dispatch(clearRowDataValue());
      dispatch(clearStepData());
    }
  };
  useEffect(() => {
    if (
      orderCategoryValue?.value === "PRJ" ||
      orderCategoryValue?.value === "CPRJ"
    ) {
      if (customerId) {
        fetchInitialOptions();
        getDraftProjectList();
      }
    }
  }, [orderCategoryValue?.value, customerId]);

  const handleChangePhases = (e) => {
    const newPhaseCount = parseInt(e.target.value);
    if (!newPhaseCount || newPhaseCount <= 0) return;
    if (editPhases) {
      setNewPhase(e.target.value - InitialPhaseQty);
    }

    const isExistingProject = existingProjectOptions?.includes(selectedProName);
    const currentPhases = Array.isArray(phasesRowData)
      ? [...phasesRowData]
      : [];
    const currentCount = currentPhases.length;

    if (isExistingProject) {
      // For existing projects: allow only increasing phase count

      if (newPhaseCount <= currentCount) {
        setToastMessage("Phase count must be increased.");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        return;
      }

      const totalUsedQty = currentPhases.reduce(
        (acc, row) => acc + Number(row.phaseViseQty || 0),
        0,
      );
      const remainingQty = selectedQty - totalUsedQty;

      const newRow = {
        phaseName: `Phase ${newPhaseCount}`,
        qty: 0,
        phaseViseQty: remainingQty > 0 ? remainingQty : 0,
        expectedProductionWeek: "",
        year: moment().add(7, "weeks").year(),
        orderPlaced: false,
      };

      const updatedRows = [...currentPhases, newRow];

      setPhasesRowData(updatedRows);
      setSelectedPhases(newPhaseCount);
      setPhasesTotalValue(
        updatedRows.reduce(
          (sum, row) => sum + Number(row.phaseViseQty || 0),
          0,
        ),
      );

      if (selectedQty !== totalUsedQty + newRow.phaseViseQty) {
        setShowPhasesAlert(true);
        setToastMessage(
          "Please adjust phase quantities to match the total quantity",
        );
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
      } else {
        setShowPhasesAlert(false);
      }

      setTimeout(() => {
        if (phaseGridRef.current?.api) {
          const api = phaseGridRef.current.api;
          const newRowIndex = updatedRows.length - 1;
          const node = api.getDisplayedRowAtIndex(newRowIndex);
          if (node) {
            api.deselectAll();
            node.setSelected(true);
            api.ensureIndexVisible(newRowIndex);
          }
        }
      }, 100);
    } else {
      const updatedRows = [];

      for (let i = 0; i < newPhaseCount; i++) {
        updatedRows.push({
          phaseName: `Phase ${i + 1}`,
          qty: 0,
          phaseViseQty: 0,
          expectedProductionWeek: "",
          year: moment().add(7, "weeks").year(),
          isCurrentPhase: true,
          orderPlaced: false,
        });
      }

      setPhasesRowData(updatedRows);
      setSelectedPhases(newPhaseCount);
      setShowPhasesAlert(true);
      setToastMessage(
        "Please adjust phase quantities to match the total quantity",
      );
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  const handleUpdateProject = () => {
    if (selectedProName?.quantity) {
      setOriginalQty(selectedProName.quantity);
      setSelectedQty(selectedProName.quantity);
    }
    setEditPhases(true);
  };

  const hasChanges = useMemo(() => {
    return (
      selectedQty !== originalQty ||
      selectedPhases !== selectedProName?.phases ||
      JSON.stringify(phasesRowData) !==
        JSON.stringify(selectedProName?.phasesData)
    );
  }, [
    selectedQty,
    originalQty,
    selectedPhases,
    selectedProName?.phases,
    phasesRowData,
    selectedProName?.phasesData,
  ]);
  const handleRevertChanges = () => {
    if (!selectedProName) return;

    setEditPhases(false);

    setSelectedQty(selectedProName.quantity || "");
    setSelectedPhases(selectedProName.phases || "");
    setPhasesRowData(
      selectedProName.phasesData
        ? JSON.parse(JSON.stringify(selectedProName.phasesData))
        : [],
    );
    setPhasesTotalValue(selectedProName.quantity || 0);
    setOriginalQty(null);
    setPhaseNameCode("");
    setTypesPhaseQty("");

    setTimeout(() => {
      if (
        phaseGridRef.current?.api &&
        selectedProName?.phasesData?.length > 0
      ) {
        const firstSelectableIndex = selectedProName.phasesData.findIndex(
          (row) => !row.orderPlaced,
        );

        if (firstSelectableIndex !== -1) {
          const api = phaseGridRef.current.api;
          api.deselectAll();
          const node = api.getDisplayedRowAtIndex(firstSelectableIndex);
          if (node) {
            node.setSelected(true);
            api.ensureIndexVisible(firstSelectableIndex);
          }
        }
      }
    }, 100);
  };
  const handleChangeTypesPhaseQty = (event) => {
    setTypesPhaseQty(Number(event.target.value));
    setRowData([]);
  };

  const isTaiwan = hasSupperUser
    ? selectedPartner?.value === 30058
    : customerId === 30058;
  const handleChangeDisplayName = (event) => {
    let inputValue = event.target.value.toUpperCase();

    const maxLength = isTaiwan ? 2 : 4;
    if (inputValue.trim() === "") {
      setToastMessage("Project Short Name cannot be empty or spaces only!");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
      setDisplayName("");
      return;
    }
    if (inputValue.includes("/") || inputValue.includes("\\")) {
      setToastMessage("Project Short Name must not contain '/' or '\\'!");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
      return;
    }
    const specialCharRegex = /^[a-zA-Z0-9()_\- ]*$/;
    if (!specialCharRegex.test(inputValue)) {
      setToastMessage("Special characters are not allowed!");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
      return;
    }

    if (inputValue.length > TOTAL_MAX_LENGTH) {
      inputValue = inputValue.slice(0, TOTAL_MAX_LENGTH);
      setToastMessage(
        `Display Name cannot exceed ${TOTAL_MAX_LENGTH} characters!`,
      );
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }

    setDisplayName(inputValue);
  };
  const checkAllCellsFilled = () => {
    return phasesRowData.every(
      (row) =>
        row.phaseName &&
        row.phaseName.trim() !== "" &&
        row.phaseViseQty &&
        row.phaseViseQty > 0 &&
        row.expectedProductionWeek,
    );
  };
  useEffect(() => {
    if (!isDraftOrder) {
      const allCellsFilled = checkAllCellsFilled();
      setIsSectionVisible(allCellsFilled);
    }
  }, [phasesRowData]);
  const isQtySufficientForPhases = (qty, phases) => {
    if (phases <= 0) return false;
    if (phases === 1) return qty >= 1;
    return qty >= 5 * (phases - 1);
  };
  const validatePhases = () => {
    let allValid = true;

    phaseGridRef.current.api.forEachNode((node) => {
      const row = node.data;
      const nameValid = !!row.phaseName && row.phaseName.trim() !== "";
      const qtyValid = Number(row.phaseViseQty) > 0;

      const weekValid =
        row.expectedProductionWeek !== null &&
        row.expectedProductionWeek !== undefined &&
        row.expectedProductionWeek !== "";

      if (!qtyValid || !weekValid || !nameValid) {
        allValid = false;
      }
    });

    setIsSubmitEnabled(!allValid);
  };
  const onCellValueChangedPhases = (event) => {
    const isRestricted = hasSupperUser
      ? selectedPartner?.value === 30058 ||
        selectedPartner?.value === 30002 ||
        selectedPartner?.value === 30005 ||
        selectedPartner?.value === 30092
      : customerId === 30058 ||
        customerId === 30002 ||
        customerId === 30005 ||
        customerId === 30092;
    if (event.colDef.field === "phaseViseQty") {
      if (editPhases && newQty && newPhases && !isRestricted) {
        if (!isQtySufficientForPhases(newQty, newPhases)) {
          handleRevertChanges();
          setToastMessage(
            `The quantity is not enough to distribute ${newPhases} phases `,
          );
          setShowToast(true);

          setTimeout(() => setShowToast(false), 5000);

          return;
        }
      }
      const newValue = Number(event.newValue);

      if (isNaN(newValue)) {
        setToastMessage("Invalid input! Only numeric values are allowed.");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        event.node.setDataValue("phaseViseQty", 0);
        return;
      }

      const rowData = [];
      phaseGridRef.current.api.forEachNode((node) => {
        rowData.push(node.data);
      });

      const lastRowIndex = rowData.length - 1;
      const rowIndex = event.node.rowIndex;
      //Restriction for taiwan and bahrain
      if (!isRestricted && rowIndex !== lastRowIndex && newValue < 5) {
        event.node.setDataValue("phaseViseQty", 5);
        setToastMessage("Phase-wise quantity minimum should be 5");
        setShowToast(true);

        setTimeout(() => setShowToast(false), 3000);
      }

      let totalExcludingLast = 0;
      phaseGridRef.current.api.forEachNode((node, index) => {
        if (index !== lastRowIndex) {
          totalExcludingLast += Number(node.data.phaseViseQty || 0);
        }
      });

      const remainingQty = selectedQty - totalExcludingLast;

      if (remainingQty < 0) {
        event.node.setDataValue("phaseViseQty", event.oldValue);
        setToastMessage("Total quantity exceeds the overall quantity!");
        setShowToast(true);

        setTimeout(() => setShowToast(false), 3000);
      }

      if (lastRowIndex >= 0) {
        const lastNode =
          phaseGridRef.current.api.getDisplayedRowAtIndex(lastRowIndex);
        lastNode.setDataValue("phaseViseQty", remainingQty);
      }
    }
    const allCellsFilled = checkAllCellsFilled();
    setIsSectionVisible(allCellsFilled);
    let newTotalValue = 0;
    phaseGridRef.current.api.forEachNode((node) => {
      newTotalValue += Number(node.data.phaseViseQty || 0);
    });
    setPhasesTotalValue(newTotalValue);
    if (selectedQty < newTotalValue || selectedQty > newTotalValue) {
      setShowPhasesAlert(true);
    } else {
      setShowPhasesAlert(false);
    }

    validatePhases();
  };

  const getRowStyle = (params) => {
    if (params.data.orderPlaced) {
      return {
        background: alpha(theme.palette.success.main, 0.25),
      };
    }
    return null;
  };

  const isRowSelectable = (params) => {
    return !params.data.orderPlaced;
  };

  const handleProductChange = (event) => {
    setProduct({
      value: event.value,
      label: event.label,
      id: event.id,
    });
    setSelectedPhases("");
    setPhasesTotalValue(0);
    setPhasesRowData([]);
    setDisplayName("");
  };

  const handleDealNameChange = (event) => {
    setSelectedDeal(event);
    setProductOptions(defaultProductOption);
    //const filterDeals = deals.find((item) => item.hs_object_id === event.value);
    const getDealProducts = event?.product_group_quoted__test_?.split(";");
    const dealUpperCase = getDealProducts?.map((item) => item?.toUpperCase());
    const changeWord = dealUpperCase?.map((item) =>
      item?.replace("KITCHEN", "KUECHEN"),
    );
    const filterProduct = defaultProductOption?.filter((item, index) => {
      return changeWord?.includes(item?.label);
    });
    setHubSpotReference(event.reference_number);
    setProductOptions(filterProduct);
    setProduct(null);
    setCostOfHubSpot(0);
  };

  useEffect(() => {
    if (hasSupperUser) {
      getCustomer();
    }
  }, [hasSupperUser]);

  useEffect(() => {
    if (selectedPartner) {
      getShowroom();
    }
  }, [selectedPartner, hasSupperUser]);
  const projectAlreadyExists = existingProjectOptions.some(
    (option) =>
      option.label.trim().toUpperCase() === currentQuery.trim().toUpperCase(),
  );
  return (
    <>
      <FormPageHeader
        componentName=" Bulk Project Order"
        pageName=" Bulk Project Order"
        currentPage=" Bulk Project Order"
        successMsg={successMsg}
        snackState={snackState}
        error={error}
      >
        {(orderCategoryValue?.value === "PRJ" ||
          orderCategoryValue?.value === "CPRJ") &&
          showProjectTypeQty && (
            <ProjectStepper
              steps={steps}
              activeStep={activeStep}
              completed={completed}
              handleStep={handleStep}
            />
          )}
      </FormPageHeader>
      <div className="px-20">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box
              className="mb-20 mt-20"
              sx={{
                p: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Partner</label>
                  {hasSupperUser ? (
                    <Select
                      placeholder={"Select Partner"}
                      name="partner"
                      value={selectedPartner}
                      options={customerOptions}
                      //  disabled={orderCategoryValue?.value === "PRJ" && steps.length>0 && selectedPartner.value?true:false}
                      onChange={(event) => {
                        setSelectedPartner({
                          value: event.value,
                          label: event.label,
                        });
                        setShowroom(null);
                        setOrderCategoryValue(null);
                        setSelectedProName(null);
                        setProduct(null);
                        setSelectedPhases("");
                        setSelectedQty("");
                        setPhasesRowData([]);
                        setRowData([]);
                        setDisplayName("");
                        setVolume("");
                        setWeight("");
                        setWG1Price("");
                        setWG2Price("");
                        setLoadingWeek(null);
                        setFormValues([
                          {
                            range: {},
                            priceGroup: {},
                            color: {},
                            carcass: {},
                            handle: {},
                          },
                        ]);
                        setDraftOrder("");
                        setIsDraftOrder(false);
                        setDraftList([]);
                        setSelectedDraftOrder(null);
                        setDRWFile(null);
                        setDrwFileId("");
                        setAppliancesDetail(null);
                        setAppliancesDetailFileId("");
                        setOrderCheckFile(null);
                        setOrderCheckFileId("");
                        setSharedLater(false);
                        setNotApplicable(false);
                        setDiscountChecked(false);
                        setSDFile(null);
                        setComment("");
                        setDrwFileSupersedes(false);
                        setUploadValue([{ uploadFile: null }]);
                      }}
                      styles={customStyles()}
                      className="select"
                    />
                  ) : (
                    <TextField
                      name="customer"
                      fullWidth
                      variant="outlined"
                      type="text"
                      value={customerName}
                      disabled
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Showroom</label>
                  <Select
                    // value={showroom}
                    value={showroom}
                    onChange={(event) =>
                      setShowroom({ value: event.value, label: event.label })
                    }
                    name="showroom"
                    options={showroomOptions}
                    styles={customStyles(
                      ((checksubmit && !showroom) || validError.showroom) &&
                        theme.palette.error.main,
                    )}
                    className="select"
                    //  disabled={orderCategoryValue?.value === "PRJ" && steps.length>0 && showroom.label?true:false }
                  />
                  <Typography
                    sx={{
                      color: "error.main",
                      fontSize: "0.875rem",
                      ml: 1.75,
                    }}
                  >
                    {checksubmit && !showroom
                      ? "This field is required"
                      : validError.showroom}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              className="mb-20 mt-20"
              sx={{
                p: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,
              }}
            >
              <Grid container spacing={2}>
                {/* <Grid item xs={3}>
                  <label className="pb-8 block">*Order Type</label>
                  <Select
                    value={docType}
                    options={docTypeOptions}
                    styles={customStyles()}
                    className="w-full"
                     onChange={(event) =>
                      setDocType({ value: event.value, label: event.label })
                    }
                  />
                </Grid> */}
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Order Category</label>
                  <Select
                    value={orderCategoryValue}
                    options={orderCategoryOptions}
                    styles={customStyles()}
                    className="w-full"
                    onChange={handleChangeOrderCategory}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Freight</label>
                  <Select
                    value={freight}
                    onChange={(event) =>
                      setFreight({
                        id: event.id,
                        value: event.value,
                        label: event.label,
                      })
                    }
                    name="freight"
                    options={freightOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>

      <Dialog
        open={open || hasBackForm}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
          fullScreen={isMobile}
      >
        <AppBar position="static" elevation={0}>
          <Toolbar className="flex w-full justify-between">
            <Typography variant="h6" color="inherit" sx={{ fontWeight: 600 }}>
              Select the Project order
            </Typography>
            <IconButton onClick={handleClose} color="inherit" size="small">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent
          sx={{
            minHeight: 500,
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.default,
            p: 3,
          }}
        >
          <ModalToast message={toastMessage} show={showToast} />
          <Paper
            variant="outlined"
            sx={{
              p: 2.5,
              mb: 3,
              borderRadius: 2,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2 }}
              color="text.primary"
            >
              Project Details
            </Typography>
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} sm={6} md={4}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  Project Name *
                </Typography>

                <CreatableSelect
                  value={selectedProName}
                  onInputChange={handleInputChange}
                  onChange={handleChangeProject}
                  isClearable
                  placeholder="Type to search or create..."
                  noOptionsMessage={() =>
                    currentQuery
                      ? `No options found for "${currentQuery}"`
                      : "Start typing to search or create a project"
                  }
                  isSearchable
                  styles={customStyles()}
                  className="capitalize"
                  formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
                  getNewOptionData={(inputValue, optionLabel) => ({
                    label: optionLabel,
                    value: inputValue,
                    __isNew__: true,
                  })}
                  options={[
                    ...(currentQuery && !projectAlreadyExists
                      ? [
                          {
                            label: `Create "${currentQuery}"`,
                            value: currentQuery,
                            __isNew__: true,
                          },
                        ]
                      : []),
                    ...existingProjectOptions,
                  ]}
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  Product *
                </Typography>
                <Select
                  value={product}
                  onChange={handleProductChange}
                  name="product"
                  options={foreCastProduct}
                  // disabled={orderCategoryValue?.value === "PRJ" && steps.length>0  && product.label?true:false }
                  styles={customStyles(
                    ((checksubmit && !product) || validError.product) &&
                      theme.palette.error.main,
                  )}
                  className="w-full"
                  isDisabled={existingProjectOptions?.includes(selectedProName)}
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  PRJ Reference
                </Typography>
                <TextField
                  value={orderReference}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  Overall Qty *
                </Typography>
                <TextField
                  value={selectedQty}
                  onChange={handleChangeQty}
                  onBlur={handleBlur}
                  fullWidth
                  variant="outlined"
                  disabled={
                    existingProjectOptions?.includes(selectedProName) &&
                    !editPhases
                  }
                  type="number"
                  inputProps={{ min: originalQty || 10 }}
                  helperText={
                    !hasSupperUser && originalQty
                      ? `Max allowed: ${Math.floor(originalQty * 1.05)}`
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  No. of Phases *
                </Typography>
                <TextField
                  value={selectedPhases}
                  onChange={handleChangePhases}
                  fullWidth
                  variant="outlined"
                  disabled={
                    existingProjectOptions?.includes(selectedProName) &&
                    !editPhases
                  }
                  type="number"
                />
              </Grid>
              {existingProjectOptions?.includes(selectedProName) &&
                !editPhases && (
                  <Grid
                    item
                    xs={12}
                    sm="auto"
                    sx={{ display: "flex", alignItems: "flex-end" }}
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleUpdateProject}
                      fullWidth
                      size="medium"
                    >
                      Update
                    </Button>
                  </Grid>
                )}
              {existingProjectOptions.includes(selectedProName) &&
                editPhases && (
                  <Grid item xs={2}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      disabled={!hasChanges}
                      size="medium"
                      onClick={handleRevertChanges}
                      fullWidth
                      sx={{ ml: 1 }}
                    >
                      Revert
                    </Button>
                  </Grid>
                )}
            </Grid>
          </Paper>

          {selectedPhases && selectedProName && product && (
            <>
              <Paper variant="outlined" sx={{ p: 2.5, mb: 3, borderRadius: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, mb: 2 }}
                  color="text.primary"
                >
                  Phases
                </Typography>

                {showPhasesAlert && (
                  <Alert severity="error" sx={{ mb: 2 }} variant="outlined">
                    {phasesTotalValue > selectedQty
                      ? "Total value exceeds " + selectedQty
                      : "Total value less " + selectedQty}
                  </Alert>
                )}

                <Box
                  sx={{
                    borderRadius: 1,
                    overflow: "hidden",
                    border: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <div
                    className={
                      theme.palette.mode === "dark"
                        ? "ag-theme-alpine-dark"
                        : "ag-theme-alpine"
                    }
                  >
                    <AgGridReact
                      ref={phaseGridRef}
                      rowData={phasesRowData}
                      columnDefs={phasesColumnDefs}
                      defaultColDef={defaultColDef}
                      autoGroupColumnDef={autoGroupColumnDef}
                      rowSelection={"single"}
                      animateRows={true}
                      headerHeight={28}
                      rowHeight={22}
                      domLayout={"autoHeight"}
                      enableRangeSelection={true}
                      onCellValueChanged={onCellValueChangedPhases}
                      onSelectionChanged={onSelectionChanged}
                      getRowStyle={getRowStyle}
                      isRowSelectable={isRowSelectable}
                      onGridReady={onGridReadyPhaseGrid}
                      cellSelection={true}
                      suppressRowClickSelection={true}
                    />
                  </div>
                  <Box
                    className="text-right"
                    sx={{
                      fontSize: 13,
                      padding: "5px 10px",
                      backgroundColor: theme.palette.background.paper,
                      border: `1px solid ${theme.palette.divider}`,
                      borderTop: "none",
                      color: theme.palette.text.primary,
                    }}
                  >
                    Total Qty/Phases: <strong>{phasesTotalValue}</strong>
                  </Box>
                </Box>
              </Paper>
            </>
          )}

          {selectedPhases &&
            selectedRows.length > 0 &&
            isSectionVisible &&
            selectedProName && (
              <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, mb: 2 }}
                  color="text.primary"
                >
                  Phase Configuration
                </Typography>

                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item xs={12} sm={4}>
                    <Typography
                      component="label"
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ display: "block", mb: 0.75 }}
                    >
                      Project Short Name
                    </Typography>
                    <TextField
                      name="displayName"
                      fullWidth
                      size="small"
                      variant="outlined"
                      type="text"
                      value={displayName}
                      onChange={handleChangeDisplayName}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Typography
                      component="label"
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ display: "block", mb: 0.75 }}
                    >
                      Project Phase
                    </Typography>
                    <TextField
                      name="projectPhase"
                      fullWidth
                      size="small"
                      variant="outlined"
                      type="text"
                      inputProps={{ maxLength: 3 }}
                      value={phaseNameCode}
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Typography
                      component="label"
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ display: "block", mb: 0.75 }}
                    >
                      Upload Types
                    </Typography>
                    <ColorButton
                      variant="contained"
                      component="label"
                      className="w-full"
                      disabled={!displayName || loadingExcel}
                    >
                      <FuseSvgIcon
                        size={18}
                        sx={{ display: "inline-block", mr: 1 }}
                      >
                        heroicons-outline:upload
                      </FuseSvgIcon>

                      {loadingExcel ? `Reading... ${excelProgress}%` : "Upload"}

                      <input
                        type="file"
                        hidden
                        onChange={handleTypeExcelUpload}
                        accept=".xlsx"
                        ref={hiddenExcelFile}
                      />
                    </ColorButton>
                  </Grid>
                </Grid>
              </Paper>
            )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SpecialProjectOrder;
